import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import "./index.css";
import App from "./App";
import { msalInstance } from "./auth/authConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

console.log("Waiting for MSAL initialize...");
msalInstance.initialize().then(() => {
  console.log("MSAL initialized, rendering app...");
  // ✅ FIXED: Removed React.StrictMode — it runs effects twice in dev mode
  // which causes MSAL loginPopup to open then immediately get cancelled.
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
});